import { NavLink } from "react-router-dom";

import classes from "./NavLinks.module.css";

// links to other pages
const NavLinks = (props) => {
  return (
    <ul className={classes.nav_links}>
      <li>
        <NavLink className={classes.navButton} to="/home"> HOME</NavLink>
      </li>
      <li>
        <NavLink to="/menu"> COCKTAILS </NavLink>
      </li>
      <li>
        <NavLink to="/search_cocktails"> SEARCH </NavLink>
      </li>
      <li>
        <NavLink to="/cabinet"> CABINET </NavLink>
      </li>
      <li>
        <NavLink to="/book_shelf"> BOOKSHELF </NavLink>
      </li>
      <li>
        <NavLink to="/help"> HELP </NavLink>
      </li>
      
    </ul>
  );
};

export default NavLinks;
